import { render } from "./RemoteWorkApply.vue?vue&type=template&id=0bfe5e89&scoped=true"
import script from "./RemoteWorkApply.vue?vue&type=script&lang=js"
export * from "./RemoteWorkApply.vue?vue&type=script&lang=js"

import "./RemoteWorkApply.vue?vue&type=style&index=0&id=0bfe5e89&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfe5e89"]])

export default __exports__